<template>
  <b-row>
    <b-col cols="10">
      <b-row>
        <b-col cols="8">
          <b-form-group>
              <label :for="`voicemail-${id}`"><i class="fa fa-envelope"></i> Voicemail</label>
              <b-select size="sm" :id="`voicemail-${id}`" :options="extensionOptions" v-model="extension"></b-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group>
              <label :for="`voicemail-options-${id}`">Options</label>
              <b-select size="sm" :id="`voicemail-options-${id}`" :options="voicemailOptions" v-model="options"></b-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="2" class="text-right">
      <b-btn-group>
        <b-btn size="sm" v-if="dirty" @click="save()" variant="success"><i class="fa fa-check"></i></b-btn>
        <b-btn size="sm" variant="danger" @click="del()"><i class="fa fa-trash"></i></b-btn>
      </b-btn-group>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Voicemail',
  props: [ 'index', 'value' ],
  computed: {
    ...mapGetters({
      extensions: 'account/extensions'
    }),
    extensionOptions () {
      return this.extensions.filter(o => o.voicemailId).map(o => ({ value: o.id, text: `${o.number} - ${o.callerId}` }))
    },
    dirty () {
      if (this.value.actionId != this.extension || this.value.options != this.options) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      extension: null,
      options: null,
      voicemailOptions: [
        { value: 'ud', text: 'Play Unavailable Message' },
        { value: 'bd', text: 'Play Busy Message' },
        { value: 'd', text: 'Skip Message' },
      ]
    }
  },
  created () {
    this.id = this.value.id
    this.extension = this.value.actionId
    this.options = this.value.options
  },
  methods: {
    async save () {
      const id = this.value.id

      const route = {
        menuId: this.value.menuId,
        optionId: this.value.optionId,
        actionType: this.value.actionType,
        actionId: this.extension,
        duration: null,
        options: this.options,
        useAccountCallerId: this.value.useAccountCallerId,
        sort: this.value.sort
      }

      if (id > 0) {
        route.id = this.value.id
        let { data } = await this.$axios.put(`/v1/menus/routes/${id}`, route)
        this.$emit('update', 'save', this.index, data)
      } else {
        let { data } = await this.$axios.post(`/v1/menus/routes`, route)
        this.$emit('update', 'save', this.index, data)
      }
    },
    async del () {
      const id = this.value.id || null
      if (id) {
        await this.$axios.delete(`/v1/menus/routes/${id}`)
      }
      this.$emit('update', 'delete', this.index)
    }
  },
  watch: {
    value: {
      handler () {
        this.id = this.value.id
        this.extension = this.value.actionId
        this.options = this.value.options
      }
    },
  }
}
</script>
